export const FETCH_POINT_PURCHASE_CONFIG = 'checkout/points_purchase_config/FETCH'
export const FETCH_POINT_PURCHASE_CONFIG_SUCCESS = `${FETCH_POINT_PURCHASE_CONFIG}_SUCCESS`
export const FETCH_POINT_PURCHASE_CONFIG_FAIL = `${FETCH_POINT_PURCHASE_CONFIG}_FAIL`
export const CHECKOUT_POINTS_PURCHASE = 'checkout/points_purchase/FETCH'
export const CHECKOUT_POINTS_PURCHASE_SUCCESS = `${CHECKOUT_POINTS_PURCHASE}_SUCCESS`
export const CHECKOUT_POINTS_PURCHASE_FAIL = `${CHECKOUT_POINTS_PURCHASE}_FAIL`

const type = {
  REQUIRES_TOKEN_VALIDATION: 'RequiresTokenValidation'
}

const initialState = {
  isLoading: false,
  config: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_POINT_PURCHASE_CONFIG:
      return {
        ...state,
        isLoading: true,
        hasSuccess: false,
        hasError: false,
        errors: [],
        id: undefined
      }
    case FETCH_POINT_PURCHASE_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        config: action.payload.data
      }
    case FETCH_POINT_PURCHASE_CONFIG_FAIL:

      let errorsConfig = []
      if (action.error.response.status === 422) {
        if (action.error.response.data.errors) {
          errorsConfig = action.error.response.data.errors
        } else {
          errorsConfig = action.error.response.data.map(error => ({ message: error.Message }))
        }
      } else if (action.error) {
        errorsConfig = [{ message: 'Erro inesperado, favor tentar mais tarde.' }]
      }

      return {
        ...state,
        isLoading: false,
        hasError: true,
        errors: errorsConfig,
        config: {}
      }
    case CHECKOUT_POINTS_PURCHASE:
      return {
        ...state,
        isLoading: true
      }
    case CHECKOUT_POINTS_PURCHASE_SUCCESS:
      return {
        ...state,
        ...ValidSecondFactorAuthentication(action)
      }
    case CHECKOUT_POINTS_PURCHASE_FAIL:
      let errors = []
      if (action.error.response.status === 422) {
        if (action.error.response.data.errors) {
          errors = action.error.response.data.errors
        } else {
          errors = action.error.response.data.map(error => ({ message: error.Message }))
        }
      }

      return {
        ...state,
        isLoading: false,
        hasError: true,
        errors,
        ...ValidOnBoardingAuthentication(action)
      }
    case 'GET_ORDER_CONFIRMATION_SUCCESS':
      return {
        ...state,
        isLoading: false,
        hasError: false,
        hasSuccess: false,
        id: undefined
      }
    case 'CLEAR_SECOND_FACTOR_AUTHENTICATION':
      return {
        ...state,
        SecondFactorAuthentication: false
      }
    case 'AUTHORIZE_TOKEN_FAIL':
      return {
        ...state,
        SecondFactorAuthentication: false
      }
    case 'AUTHORIZE_TOKEN_SUCCESS':
      return {
        ...state,
        ...validationTokenSuccess(action)
      }
    default: return state
  }
}

const validationTokenSuccess = (action) => {
  if (action.payload.status === 200) {
    return {
      hasSuccess: true
    }
  } else {
    return {
      hasSuccess: false
    }
  }
}

const ValidOnBoardingAuthentication = (action) => {
  const status = action.error.response.status

  if (status === 406) {
    return {
      SecondFactorAuthentication: true,
      SecondFactorAuthenticationConfirmed: false
    }
  }
}

const ValidSecondFactorAuthentication = (action) => {
  const requiredTokenValidation = (type.REQUIRES_TOKEN_VALIDATION === action.payload.data.status)

  return {
    hasSuccess: !requiredTokenValidation,
    SecondFactorAuthentication: requiredTokenValidation,
    isLoading: false,
    id: action.payload.data.id,
    confirmedOrderId: action.payload.data.id,
    SecondFactorAuthenticationConfirmed: true,
    phone: action.payload.data.phone
  }
}

export const clearSecondFactorAuthentication = () => ({
  type: 'CLEAR_SECOND_FACTOR_AUTHENTICATION'
})

export const fetchPointPurchaseConfiguration = (vendorId = process.env.REACT_APP_VENDOR_PURCHASE_POINTS) => ({
  type: FETCH_POINT_PURCHASE_CONFIG,
  payload: {
    client: 'cloudloyalty',
    request: {
      url: `/v2/purchase/configuration`,
      params: { vendorId }
    }
  }
})

export const checkoutPointsPurchase = (purchase) => ({
  type: CHECKOUT_POINTS_PURCHASE,
  payload: {
    client: 'cloudloyalty',
    request: {
      url: `/v1/purchases/points`,
      method: 'post',
      data: {
        vendorId: process.env.REACT_APP_VENDOR_PURCHASE_POINTS,
        ...purchase
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/Checkout/PointsPurchase/ducks.js